<template>
  <div>
    <zx-table
      :tableData="tableData"
      :option="table"
      :page="page"
      :searchDesc="searchDesc"
      @searchSubmit="searchSubmit"
      @handleSelectionChange="handleSelectionChange"
      @delBtn="delBtn"
      @refresh-change="getlist"
      @addSubmit="addSubmit"
      @etidSubmit="etidSubmit"
      @refreshBtn="refreshBtn"
    >
    </zx-table>
    <ele-form-dialog
      v-model="formData"
      :formDesc="formDesc"
      :request-fn="handleSubmit"
      :rules="rules"
      labelPosition="left"
      formBtnSize="mini"
      :dialogAttrs="{
        center: false,
        'destroy-on-close': true,
        'custom-class': 'formD'
      }"
      v-dialogdrag
      :visible.sync="dialogFormVisible"
      @request-success="handleSuccess"
      :title="formTitle"
    >
    </ele-form-dialog>
  </div>
</template>

<script>
import * as plan from "@/api/plan/plan.js";
import xzTable from "@/components/xz-table.vue";
export default {
  components: {
    "zx-table": xzTable
  },
  data() {
    return {
      searchDesc: {
        subject: {
          type: "input",
          label: "计划名称",
          attrs: {}
        },
        loop_type: {
          type: "select",
          label: "执行周期",
          attrs: {},
          options: [
            {
              text: "每月",
              value: "month"
            },
            {
              text: "每周",
              value: "week"
            },
            {
              text: "每天",
              value: "day"
            },
            {
              text: "每小时",
              value: "hour"
            },
            {
              text: "每隔",
              value: "now"
            }
          ]
        },
        run_file: {
          field: "run_file",
          label: "执行文件",
          type: "select",
          options: plan.getCronFileList.r()
        },
        isopen: {
          label: "状态",
          type: "select",
          options: [
            {
              text: "启用",
              value: 1
            },
            {
              text: "关闭",
              value: 0
            }
          ]
        }
      },
      page: {
        total: 1,
        pagerCount: 1,
        currentPage: 1,
        pageSize: 10,
        pageSizes: [1, 3, 10, 20, 30, 40, 50, 100],
        layout: "total, sizes, prev, pager, next, jumper",
        background: true
      },
      table: {
        title: "计划",
        // 多选 默认:false;
        selection: false,
        // 单选高亮
        current: true,
        //搜索框 默认:false;
        searchBtn: true,
        //索引 默认:true;
        index: true,
        // 刷新 默认:true;
        refreshBtn: true,
        // 添加 默认:true;
        addBtn: false,
        // 编辑 默认:true;
        editBtn: false,
        // 删除  默认:true;
        delBtn: true,
        // 折叠筐 默认:false;
        expand: true,
        expandStyle: "width:50%;display:inline-flex;",
        column: [
          {
            prop: "subject",
            // 列名
            label: "计划名称",
            hide: true,
            type: "input"
          },
          {
            prop: "loop_type",
            // 列名
            label: "循环周期",
            hide: true,
            type: "input",
            show: "tag",
            tagtype: [
              {
                text: "每月",
                value: "month"
              },
              {
                text: "每周",
                value: "week"
              },
              {
                text: "每天",
                value: "day"
              },
              {
                text: "每小时",
                value: "hour"
              },
              {
                text: "每隔",
                value: "now"
              }
            ]
          },
          {
            prop: "cron_file",
            // 列名
            label: "执行文件",
            hide: true,
            type: "input"
          },
          {
            prop: "isopen",
            // 列名
            label: "状态",
            hide: true,
            show: "tag",
            tagtype: [
              {
                text: "启用",
                value: "启用",
                type: "success"
              },
              {
                text: "关闭",
                value: "关闭",
                type: "danger"
              }
            ]
          },
          {
            prop: "loop_daytime",
            // 列名
            childrenProp: "format",
            label: "执行详情",
            hide: false,
            type: "input"
          },
          {
            prop: "create_time",
            // 列名
            label: "创建时间",
            hide: true,
            type: "input"
          },
          {
            prop: "update_time",
            // 列名
            label: "更新时间",
            hide: false,
            type: "input"
          },
          {
            prop: "modified_time",
            // 列名
            label: "上一次执行时间",
            hide: false,
            type: "input"
          },
          {
            prop: "next_time",
            // 列名
            label: "下次执行时间",
            hide: false,
            type: "input"
          }
        ],
        btnList: [
          {
            name: "编辑",
            //  size:'mini',
            type: "text",
            show: false,
            click: (id, row, index) => {
              this.screeningEditData(row);
            }
          },
          {
            name: "查看",
            //  size:'mini',
            type: "text",
            show: false,
            click: (id, row, index) => {
              plan.getCronInfo
                .r({
                  id: row.cron_id
                })
                .then(res => {});
            }
          }
        ],
        btnNavLeft: [
          {
            text: "新增",
            size: "mini",
            type: "success",
            click: () => {
              this.formData = {};
              this.dialogFormVisible = true;
            }
          }
        ]
      },
      formTitle: "计划",
      tableData: [],
      dialogFormVisible: false,
      formData: {},
      formDesc: {
        subject: {
          type: "input",
          label: "计划名称",
          attrs: {},
          required: true
        },
        cron_file: {
          type: "select",
          label: "执行文件",
          attrs: {
            filterable: true
          },
          options: plan.getCronFileList.r(),
          required: true
        },
        isopen: {
          type: "select",
          label: "状态",
          attrs: {},
          required: true,
          default: 1,
          options: [
            {
              text: "启用",
              value: 1
            },
            {
              text: "关闭",
              value: 0
            }
          ]
        },
        loop_type: {
          required: true,
          layout: 8,
          type: "select",
          label: "执行周期",
          attrs: {},
          options: [
            {
              text: "每月",
              value: "month"
            },
            {
              text: "每周",
              value: "week"
            },
            {
              text: "每天",
              value: "day"
            },
            {
              text: "每小时",
              value: "hour"
            },
            {
              text: "每隔",
              value: "now"
            }
          ]
        },
        month_day: {
          required: true,
          layout: 8,
          type: "select",
          label: "几号",
          vif(data) {
            return data.loop_type === "month";
          },
          attrs: {},
          options: this.getTimeData("day")
        },
        month_hour: {
          required: true,
          layout: 8,
          vif(data) {
            return data.loop_type === "month";
          },
          type: "select",
          label: "几点",
          attrs: {},
          options: this.getTimeData("hour")
        },
        week_day: {
          required: true,
          layout: 8,
          vif(data) {
            return data.loop_type === "week";
          },
          type: "select",
          label: "周几",
          attrs: {},
          options: this.getTimeData("week")
        },
        week_hour: {
          required: true,
          layout: 8,
          vif(data) {
            return data.loop_type === "week";
          },
          type: "select",
          label: "几点",
          attrs: {},
          options: this.getTimeData("hour")
        },
        day_hour: {
          required: true,
          layout: 8,
          vif(data) {
            return data.loop_type === "day";
          },
          type: "select",
          label: "几点",
          attrs: {},
          options: this.getTimeData("hour")
        },
        hour_minute: {
          required: true,
          layout: 8,
          vif(data) {
            return data.loop_type === "hour";
          },
          type: "select",
          label: "几分",
          attrs: {},
          options: this.getTimeData("minute")
        },
        now_type: {
          required: true,
          layout: 6,
          vif(data) {
            return data.loop_type === "now";
          },
          type: "select",
          label: "每隔",
          default: "month",
          attrs: {},
          options: [
            {
              text: "月",
              value: "month"
            },
            {
              text: "天",
              value: "day"
            },
            {
              text: "时",
              value: "hour"
            },
            {
              text: "分",
              value: "minute"
            }
          ]
        },
        now_time: {
          required: true,
          layout: 8,
          vif(data) {
            return data.loop_type === "now";
          },
          sytle: "margin-left:-100px;",
          type: "number",
          label(data) {
            switch (data.now_type) {
              case "month":
                return "月";

              case "day":
                return "天";

              case "hour":
                return "小时";

              case "minute":
                return "分钟";
            }
          },
          attrs: {
            size: "small",
            min: 1,
            controls: false
          }
        }
      },
      rules: {}
    };
  },
  created() {
    this.getlist();
  },
  methods: {
    // 数据格式
    getTimeData(e) {
      let data = {
        day: [],
        hour: [],
        minute: [],
        week: []
      };
      for (let index = 0; index < 60; index++) {
        if (index + 1 < 7) {
          data.week.push({
            text: "周" + (index + 1),
            value: index + 1
          });
        }
        if (index + 1 < 31) {
          data.day.push({
            text: index + 1 + "号",
            value: index + 1
          });
        }
        if (index < 24) {
          data.hour.push({
            text: index + "点",
            value: index
          });
        }
        data.minute.push({
          text: index + 1 + "分",
          value: index + 1
        });
      }
      return data[e];
    },
    // 表单提交
    handleSubmit(data) {
      if (data.id) {
        plan.editCron.r(data).then(res => {
          this.dialogFormVisible = false;
          this.getlist();
        });
      } else {
        plan.addCron.r(data).then(res => {
          this.dialogFormVisible = false;
          this.getlist();
        });
      }
    },
    handleSuccess() {},
    // 编辑数据删选
    screeningEditData(data) {
      let editData = {
        id: data.cron_id,
        subject: data.subject,
        loop_type: data.loop_type,
        cron_file: data.cron_file,
        isopen: data.isopen,
        ...data.loop_daytime.loopDayTime
      };
      this.formData = editData;
      this.dialogFormVisible = true;
    },
    getlist(e) {
      let that = this;
      let param;
      if (e) {
        that.page = e;
        param = {
          page: e.currentPage,
          limit: e.pageSize
        };
      } else {
        param = {
          page: this.page.currentPage,
          limit: this.page.pageSize
        };
      }
      if (this.searchData) {
        param = {
          page: this.page.currentPage,
          limit: this.page.pageSize,
          ...this.searchData
        };
      }
      plan.getCronList.r(param).then(res => {
        that.tableData = res.list;
        that.page.total = res.total;
      });
    },
    // 筛选条件
    searchSubmit(e) {
      this.searchData = e;
      this.getlist();
    },
    // 多选
    handleSelectionChange(e) {},
    // 添加提交
    addSubmit(form) {
      plan.addCron.r(form).then(res => {
        this.$message.success("创建成功");
        this.getlist();
      });
    },
    // 编辑
    etidSubmit(form) {
      plan.editCron.r(form).then(res => {
        this.$message.success("修改成功");
        this.getlist();
      });
    },
    // 删除
    delBtn(form) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          plan.deleteCron
            .r({
              id: form.cron_id
            })
            .then(res => {
              this.$message.success("计划删除成功");
              this.getlist();
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 刷新
    refreshBtn(e) {
      this.getlist();
    }
  }
};
</script>

<style lang="scss" scoped></style>
